import "./SeoForStartups.module.css";
import Header from "@/reusable_sections/Header";
import StartupHero from "./sections/StartupHero";
import Benefits from "./sections/Benefits";
import ConsultancyLinks from "./sections/ConsultancyLinks";
import Footer from "@/reusable_sections/Footer";
export default function SeoForStartupsPage() {
  return <div>
      <Header />
      <StartupHero />
      <Benefits />
      <ConsultancyLinks />
      <Footer />
    </div>;
}